import { useState, useEffect } from 'react';

const useUnsavedValue = ({ initialValue, comparator = (a, b) => a === b }) => {
    const [value, setValue] = useState(initialValue);
    const [isDifferent, setIsDifferent] = useState(
        !comparator(initialValue, value)
    );

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
        setIsDifferent(!comparator(initialValue, value));
    }, [initialValue, value]); // eslint-disable-line react-hooks/exhaustive-deps

    return {
        value,
        setValue,
        isDifferent,
    };
};

export default useUnsavedValue;
